import { render, staticRenderFns } from "./templateContentMessage.vue?vue&type=template&id=42792768&"
import script from "./templateContentMessage.vue?vue&type=script&lang=ts&"
export * from "./templateContentMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports